import React, { useEffect, useState } from 'react';
import {
  ESTATUS_OPCION_LABELS,
  ESTATUS_OPCION_PROSPECTO,
  labelFromMap,
} from '../../services/prospectosCrmService';

const INITIAL = {
  tipoReferencia: 'INMUEBLE',
  inmuebleId: '',
  desarrolloId: '',
  proyectoId: '',
  modeloId: '',
  unidadId: '',
  estatus: 'SUGERIDA',
  comentarios: '',
};

const getValueForType = (form) => {
  switch (form.tipoReferencia) {
    case 'DESARROLLO':
      return form.desarrolloId;
    case 'PROYECTO':
      return form.proyectoId;
    case 'MODELO':
      return form.modeloId;
    case 'UNIDAD':
      return form.unidadId;
    case 'INMUEBLE':
    default:
      return form.inmuebleId;
  }
};

export default function ProspectoOpcionModal({
  opcion,
  inmuebles = [],
  desarrollos = [],
  proyectos = [],
  modelos = [],
  unidades = [],
  onProyectoChange,
  onClose,
  onSubmit,
  saving = false,
}) {
  const [form, setForm] = useState(() => ({
    ...INITIAL,
    ...(opcion || {}),
    tipoReferencia: opcion?.tipoReferencia || INITIAL.tipoReferencia,
    estatus: opcion?.estatus || INITIAL.estatus,
    comentarios: opcion?.comentarios || '',
  }));
  const [error, setError] = useState('');

  useEffect(() => {
    if (form.tipoReferencia === 'MODELO' || form.tipoReferencia === 'UNIDAD') {
      onProyectoChange?.(form.proyectoId);
    }
  }, [form.proyectoId, form.tipoReferencia, onProyectoChange]);

  const update = (event) => {
    const { name, value } = event.target;
    setForm((actual) => {
      const next = { ...actual, [name]: value };
      if (name === 'tipoReferencia') {
        next.inmuebleId = '';
        next.desarrolloId = '';
        next.proyectoId = '';
        next.modeloId = '';
        next.unidadId = '';
      }
      if (name === 'proyectoId') {
        next.modeloId = '';
        next.unidadId = '';
      }
      return next;
    });
    setError('');
  };

  const submit = (event) => {
    event.preventDefault();

    if (!getValueForType(form)) {
      setError('Selecciona una opcion inmobiliaria.');
      return;
    }

    onSubmit?.({
      tipoReferencia: form.tipoReferencia,
      inmuebleId: form.tipoReferencia === 'INMUEBLE' ? form.inmuebleId : null,
      desarrolloId: form.tipoReferencia === 'DESARROLLO' ? form.desarrolloId : null,
      proyectoId: ['PROYECTO', 'MODELO', 'UNIDAD'].includes(form.tipoReferencia) ? form.proyectoId : null,
      modeloId: form.tipoReferencia === 'MODELO' ? form.modeloId : null,
      unidadId: form.tipoReferencia === 'UNIDAD' ? form.unidadId : null,
      estatus: form.estatus,
      comentarios: form.comentarios.trim() || null,
    });
  };

  return (
    <div className="crm-prospectos-modal-overlay" role="presentation" onMouseDown={onClose}>
      <section className="crm-prospectos-modal" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
        <div className="crm-prospectos-modal-head">
          <div>
            <p className="crm-prospectos-eyebrow">Opciones inmobiliarias</p>
            <h2>{opcion ? 'Editar opcion' : 'Agregar opcion'}</h2>
          </div>
          <button type="button" onClick={onClose} disabled={saving} aria-label="Cerrar">x</button>
        </div>
        <form onSubmit={submit} className="crm-prospectos-modal-body">
          <label>
            <span>Tipo de referencia</span>
            <select name="tipoReferencia" value={form.tipoReferencia} onChange={update}>
              <option value="INMUEBLE">Inmueble</option>
              <option value="DESARROLLO">Desarrollo</option>
              <option value="PROYECTO">Proyecto</option>
              <option value="MODELO">Modelo</option>
              <option value="UNIDAD">Unidad</option>
            </select>
          </label>

          {form.tipoReferencia === 'INMUEBLE' ? (
            <label>
              <span>Inmueble</span>
              <select name="inmuebleId" value={form.inmuebleId} onChange={update}>
                <option value="">Selecciona inmueble</option>
                {inmuebles.map((item) => <option key={item.id} value={item.id}>{item.titulo}</option>)}
              </select>
            </label>
          ) : null}

          {form.tipoReferencia === 'DESARROLLO' ? (
            <label>
              <span>Desarrollo</span>
              <select name="desarrolloId" value={form.desarrolloId} onChange={update}>
                <option value="">Selecciona desarrollo</option>
                {desarrollos.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
              </select>
            </label>
          ) : null}

          {['PROYECTO', 'MODELO', 'UNIDAD'].includes(form.tipoReferencia) ? (
            <label>
              <span>Proyecto</span>
              <select name="proyectoId" value={form.proyectoId} onChange={update}>
                <option value="">Selecciona proyecto</option>
                {proyectos.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
              </select>
            </label>
          ) : null}

          {form.tipoReferencia === 'MODELO' ? (
            <label>
              <span>Modelo</span>
              <select name="modeloId" value={form.modeloId} onChange={update} disabled={!form.proyectoId}>
                <option value="">Selecciona modelo</option>
                {modelos.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
              </select>
            </label>
          ) : null}

          {form.tipoReferencia === 'UNIDAD' ? (
            <label>
              <span>Unidad</span>
              <select name="unidadId" value={form.unidadId} onChange={update} disabled={!form.proyectoId}>
                <option value="">Selecciona unidad</option>
                {unidades.map((item) => <option key={item.id} value={item.id}>{item.codigo} - {item.modeloNombre}</option>)}
              </select>
            </label>
          ) : null}

          <label>
            <span>Estatus de opcion</span>
            <select name="estatus" value={form.estatus} onChange={update}>
              {ESTATUS_OPCION_PROSPECTO.map((estatus) => (
                <option key={estatus} value={estatus}>{labelFromMap(ESTATUS_OPCION_LABELS, estatus)}</option>
              ))}
            </select>
          </label>
          <label>
            <span>Comentarios</span>
            <textarea name="comentarios" value={form.comentarios} onChange={update} rows="3" />
          </label>
          {error ? <p className="crm-prospectos-feedback is-error">{error}</p> : null}
          <div className="crm-prospectos-modal-actions">
            <button type="submit" className="is-primary" disabled={saving}>{saving ? 'Guardando...' : 'Guardar opcion'}</button>
            <button type="button" onClick={onClose} disabled={saving}>Cancelar</button>
          </div>
        </form>
      </section>
    </div>
  );
}
